import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_22588_28963" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_22588_28963)">
      <path
        d="M9.9987 9.99935C10.457 9.99935 10.8494 9.83615 11.1758 9.50976C11.5022 9.18338 11.6654 8.79101 11.6654 8.33268C11.6654 7.87435 11.5022 7.48199 11.1758 7.1556C10.8494 6.82921 10.457 6.66601 9.9987 6.66601C9.54036 6.66601 9.148 6.82921 8.82161 7.1556C8.49523 7.48199 8.33203 7.87435 8.33203 8.33268C8.33203 8.79101 8.49523 9.18338 8.82161 9.50976C9.148 9.83615 9.54036 9.99935 9.9987 9.99935ZM9.9987 18.3327C7.76259 16.4299 6.09245 14.6625 4.98828 13.0306C3.88411 11.3987 3.33203 9.88824 3.33203 8.49935C3.33203 6.41601 4.00217 4.75629 5.34245 3.52018C6.68273 2.28407 8.23481 1.66602 9.9987 1.66602C11.7626 1.66602 13.3147 2.28407 14.6549 3.52018C15.9952 4.75629 16.6654 6.41601 16.6654 8.49935C16.6654 9.88824 16.1133 11.3987 15.0091 13.0306C13.9049 14.6625 12.2348 16.4299 9.9987 18.3327Z"
        fill="#858585"
      />
    </g>
  </svg>
);

export default Icon;
